const data: HomeSlider[] = [
  {
    caption: "Mitsui Garden Hotel Jingugaien Tokyo Premier",
    image: require("@/assets/assets/imgs/HomeSlider/01/MGH-Gaien-4.jpg")
  },
  {
    caption: "Mitsui Garden Hotel Jingugaien Tokyo Premier",
    image: require("@/assets/assets/imgs/HomeSlider/01/MGH-Gaien-10.jpg")
  },
  {
    caption: "Mitsui Garden Hotel Jingugaien Tokyo Premier",
    image: require("@/assets/assets/imgs/HomeSlider/01/MGH-Gaien-11.jpg")
  },
  {
    caption: "Mitsui Garden Hotel Roppongi Tokyo Premier",
    image: require("@/assets/assets/imgs/HomeSlider/01/MGH-Roppongi-5.jpg")
  },
  {
    caption: "Mitsui Garden Hotel Fukuoka Nakasu",
    image: require("@/assets/assets/imgs/HomeSlider/02/MGH-Nakasu-16.jpg")
  },
  {
    caption: "Mitsui Garden Hotel Roppongi Tokyo Premier",
    image: require("@/assets/assets/imgs/HomeSlider/02/MGH-Roppongi-2.jpg")
  },
  {
    caption: "Mitsui Garden Hotel Toyosu PREMIER",
    image: require("@/assets/assets/imgs/HomeSlider/02/MGH-Toyosu-2.jpg")
  },
  {
    caption: "Mitsui Garden Hotel Jingugaien Tokyo Premier",
    image: require("@/assets/assets/imgs/HomeSlider/03/MGH-Gaien-3.jpg")
  },
  {
    caption: "Mitsui Garden Hotel Nihonbashi Premier",
    image: require("@/assets/assets/imgs/HomeSlider/03/MGH-Nihonbashi-11.jpg")
  },
  {
    caption: "Mitsui Garden Hotel Roppongi Tokyo Premier",
    image: require("@/assets/assets/imgs/HomeSlider/03/MGH-Roppongi-11.jpg")
  },
  {
    caption: "Mitsui Garden Hotel Jingugaien Tokyo Premier",
    image: require("@/assets/assets/imgs/HomeSlider/04/MGH-Gaien-11.jpg")
  },
  {
    caption: "Mitsui Garden Hotel Fukuoka Nakasu",
    image: require("@/assets/assets/imgs/HomeSlider/04/MGH-Nakasu-7.jpg")
  },
  {
    caption: "Mitsui Garden Hotel Nihonbashi Premier",
    image: require("@/assets/assets/imgs/HomeSlider/04/MGH-Nihonbashi-6.jpg")
  },
  {
    caption: "Mitsui Garden Hotel Toyosu PREMIER",
    image: require("@/assets/assets/imgs/HomeSlider/04/MGH-Toyosu-8.jpg")
  },
  {
    caption: "Mitsui Garden Hotel Jingugaien Tokyo Premier",
    image: require("@/assets/assets/imgs/HomeSlider/05/MGH-Gaien-6.jpg")
  },
  {
    caption: "Mitsui Garden Hotel Fukuoka Nakasu",
    image: require("@/assets/assets/imgs/HomeSlider/05/MGH-Nakasu-2.jpg")
  },
  {
    caption: "Mitsui Garden Hotel Nihonbashi Premier",
    image: require("@/assets/assets/imgs/HomeSlider/05/MGH-Nihonbashi-1.jpg")
  },
  {
    caption: "Mitsui Garden Hotel Toyosu PREMIER",
    image: require("@/assets/assets/imgs/HomeSlider/05/MGH-Toyosu-5.jpg")
  },
  {
    caption: "Mitsui Garden Hotel Fukuoka Nakasu",
    image: require("@/assets/assets/imgs/HomeSlider/07/MGH-Nakasu-8.jpg")
  },
  {
    caption: "Mitsui Garden Hotel Toyosu PREMIER",
    image: require("@/assets/assets/imgs/HomeSlider/07/MGH-Toyosu-7.jpg")
  },
  {
    caption: "Mitsui Garden Hotel Toyosu PREMIER",
    image: require("@/assets/assets/imgs/HomeSlider/07/MGH-Toyosu-8.jpg")
  },
  {
    caption: "Mitsui Garden Hotel Jingugaien Tokyo Premier",
    image: require("@/assets/assets/imgs/HomeSlider/08/MGH-Gaien-9.jpg")
  },
  {
    caption: "Mitsui Garden Hotel Fukuoka Gion",
    image: require("@/assets/assets/imgs/HomeSlider/08/MGH-Gion-15.jpg")
  },
  {
    caption: "Mitsui Garden Hotel Roppongi Tokyo Premier",
    image: require("@/assets/assets/imgs/HomeSlider/08/MGH-Roppongi-12.jpg")
  },
  {
    caption: "TOBA HOTEL INTERNATIONAL",
    image: require("@/assets/assets/imgs/HomeSlider/09/tobahotel.jpg")
  },
  {
    caption: "Mitsui Garden Hotel Yokohama Minatomirai Premier",
    image: require("@/assets/assets/imgs/HomeSlider/09/MGH-Yokohama-1.jpg")
  },
  {
    caption: "Mitsui Garden Hotel Yokohama Minatomirai Premier",
    image: require("@/assets/assets/imgs/HomeSlider/09/MGH-Yokohama-2.jpg")
  },
  {
    caption: "Mitsui Garden Hotel Yokohama Minatomirai Premier",
    image: require("@/assets/assets/imgs/HomeSlider/09/MGH-Yokohama-3.jpg")
  },
];
export default data;
